import React, { useState } from 'react'
import { apiPost, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import AlertUI from '../../generic/AlertUI'
import { IconButton, Tooltip, Typography } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueLabel } from '../../generic/systemValues/systemValueLabel'
import createDialogTitle from '../../generic/utilities/dialogUtil'
import ReplayIcon from '@mui/icons-material/Replay'
import { useAuthorization } from '../../generic/hooks/useAuthorization'
import NoOk from '../../../images/NO_OK.png'
import Warning from '../../../images/Warning.png'
import { clusterSyncReasonText } from './clusterSyncReasonText'
const PendingSyncRequests = (props) => {
  const [AlertElement, showAlert] = AlertUI()
  const [selectedRow, setSelectedRow] = useState({})
  const [showCancelDialog, setShowCancelDialog] = useState(false)
  const isUserAuthorized = useAuthorization()
  const { t_ } = useSmartTranslation()

  const getTableData = async (pagination) => {
    return await apiPost('pendingSyncRequests', pagination)
  }
  const imgStyle = {
    verticalAlign: 'middle',
    height: '1.8rem',
    width: '1.8rem'
  }
  const columns = [
    {
      name: t_('Reference'),
      field: 'reference'
    },
    {
      name: t_('Type'),
      field: 'type',
      // The synchronised resource (cluster_sync_resource), seeded by MIC: translated by its code (P17).
      render: (row) => systemValueLabel(t_, 'cluster_sync_resource', row.type || '')
    },
    {
      name: t_('Creation date'),
      field: 'creationDate',
      type: 'dateTimePicker'
    },
    {
      name: t_('Node'),
      field: 'node'

    },
    {
      name: t_('Status'),
      field: 'failed',
      type: 'boolean',
      render: (row) => {
        let src = null
        if (row?.failed) {
          src = NoOk
        } else {
          src = Warning
        }
        return (
          <img
            style={imgStyle}
            src={src}
            alt=''
          />
        )
      }
    },
    {
      name: t_('Description'),
      field: 'description',
      // JUP-6/S97: con `reasonCode` se muestra el motivo TRADUCIDO, la misma palabra que el indicador
      // de la ventana de OFs. Sin él -- una petición que solo espera -- el texto de siempre.
      render: (row) => clusterSyncReasonText(row?.reasonCode, row?.description, t_)
    }
  ]

  const actions = {
    custom: [
      {
        contextMenu: false,
        render: (row) => {
          return (
            <Tooltip title={t_('Reset request')}>
              <IconButton
                disabled={!isUserAuthorized('PENDING_SYNC_REQUESTS_RESYNC') || !row.failed}
                onClick={() => {
                  setSelectedRow(row)
                  setShowCancelDialog(true)
                }}
              >
                <ReplayIcon />
              </IconButton>
            </Tooltip>
          )
        }
      }
    ]
  }

  const handleAccept = async () => {
    try {
      await apiPut('resetPendingRequest?id=' + selectedRow.id)
      showAlert({
        title: t_('Success'),
        message: t_('Request successfully resetted'),
        severity: 'success'
      })
      setSelectedRow({})
    } catch (error) {
      showAlert({
        title: t_('Error resetting request'),
        message: t_(error.message),
        severity: 'error'
      })
    }
    setShowCancelDialog(false)
  }

  return (
    <>
      {AlertElement}
      <SmartDialog
        setOpen={showCancelDialog}
        title={createDialogTitle({ title: t_('Reset request') + '?', icon: ReplayIcon, color: 'primary' })}
        cancelCallback={() => setShowCancelDialog(false)}
        renderComponent={<Typography>{t_('Are you sure you want to reset this request?')}</Typography>}
        acceptCallback={handleAccept}
      />
      <SmartMateriaUITable
        title={<Typography color='primary'>{t_('Pending sync requests')} </Typography>}
        columns={columns}
        dataFetch={getTableData}
        actions={actions}
        multipleSelection={false}
        pageable
        const sortOptions={{
          default: {
            field: 'creationDate',
            direction: -1
          }
        }}
      />
    </>
  )
}

export default PendingSyncRequests
